<div class="gm">
  <div class="gm-head">
    <div>
      <h2>{{ datos.nombre }}</h2>
      <span class="gm-tier">{{ datos.tier }}</span>
      <span class="gm-dueno" *ngIf="gestion?.duenoEmail">· {{ gestion?.duenoEmail }}</span>
      <span class="gm-dueno falta" *ngIf="sinDueno">· sin dueño</span>
    </div>
    <button mat-icon-button (click)="cerrar()" title="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="gm-cargando" *ngIf="cargando">Cargando la ficha…</div>

  <div class="gm-body" *ngIf="!cargando">
    <!-- ------------------------------------------------------ quién responde -->
    <div class="gm-bloque">
      <div class="gm-t">Quién responde</div>
      <div class="gm-fila-botones">
        <button
          mat-flat-button
          color="primary"
          *ngIf="sinDueno && miSub"
          (click)="tomarCuenta()"
          [disabled]="guardando"
        >
          <mat-icon>person_add</mat-icon> Tomar esta cuenta
        </button>
        <span class="gm-ayuda" *ngIf="sinDueno">
          Una alerta sin dueño no cuenta como gestionada, y si es un whale en rojo
          entra en el indicador que tiene que dar cero.
        </span>
        <button
          mat-stroked-button
          *ngIf="!sinDueno"
          (click)="liberarCuenta()"
          [disabled]="guardando"
        >
          Dejar sin dueño
        </button>
        <span class="gm-ayuda" *ngIf="esMia">Es tuya desde el {{ gestion?.asignadoAt | date: 'dd/MM HH:mm' }}.</span>
      </div>
    </div>

    <!-- --------------------------------------------------------- el registro -->
    <div class="gm-bloque">
      <div class="gm-t">Registrar un contacto</div>
      <p class="gm-ayuda">
        La fecha del último contacto sale de acá, no se teclea: es el reloj del
        indicador de tiempo de reacción.
      </p>

      <div class="gm-guion">
        <button
          *ngFor="let g of guion"
          class="gm-guion-item"
          [class.on]="escenario === g.codigo"
          (click)="escenario = g.codigo"
          type="button"
        >
          <b>{{ g.titulo }}</b>
          <span>{{ g.que }}</span>
        </button>
      </div>

      <div class="gm-campos">
        <label>
          Canal
          <select [(ngModel)]="canal">
            <option *ngFor="let c of canales" [value]="c">{{ c }}</option>
          </select>
        </label>

        <label>
          Resultado
          <select [(ngModel)]="resultado">
            <option value="">—</option>
            <option *ngFor="let r of resultados" [value]="r">
              {{ r.toLowerCase().replace('_', ' ') }}
            </option>
          </select>
        </label>

        <label class="ancho">
          Qué dijo
          <input [(ngModel)]="detalle" placeholder="Sus palabras, no un resumen…" />
        </label>
      </div>

      <div class="gm-fila-botones">
        <button
          mat-flat-button
          color="primary"
          (click)="registrarContacto()"
          [disabled]="registrando"
        >
          {{ registrando ? 'Registrando…' : 'Registrar contacto' }}
        </button>
        <button mat-stroked-button (click)="agregarNota()">Sólo una nota</button>
      </div>
    </div>

    <!-- ------------------------------------------------------------ el plan -->
    <div class="gm-bloque">
      <div class="gm-t">Motivo y próxima acción</div>
      <div class="gm-campos">
        <label>
          Estado del caso
          <select [(ngModel)]="estadoGestion">
            <option *ngFor="let e of estados" [value]="e">
              {{ e.toLowerCase().replace('_', ' ') }}
            </option>
          </select>
        </label>

        <label>
          Por qué bajó
          <select [(ngModel)]="motivoCodigo">
            <option value="">sin averiguar</option>
            <option *ngFor="let m of motivos" [value]="m">
              {{ m.toLowerCase().replace('_', ' ') }}
            </option>
          </select>
        </label>

        <label class="ancho">
          Detalle del motivo
          <input [(ngModel)]="motivoDetalle" placeholder="Lo que explica el código de arriba" />
        </label>

        <label class="ancho">
          Próxima acción
          <input [(ngModel)]="proximaAccion" placeholder="Qué se va a hacer, concreto" />
        </label>

        <label>
          Para cuándo
          <input type="date" [(ngModel)]="proximaAccionAt" />
        </label>
      </div>

      <div class="gm-campos" *ngIf="puedeOfrecerTasa">
        <label>
          Tasa preferente (puntos)
          <input
            type="number"
            step="0.1"
            min="0"
            [max]="datos.tasaPreferenteMaxPct"
            [(ngModel)]="tasaPreferentePct"
          />
        </label>
        <label>
          Vence
          <input type="date" [(ngModel)]="tasaPreferenteHasta" />
        </label>
        <span class="gm-ayuda">
          Autorizado hasta {{ datos.tasaPreferenteMaxPct }} puntos. Si dejás la
          fecha vacía, se pone el vencimiento por defecto.
        </span>
      </div>

      <p class="gm-ayuda aviso" *ngIf="!puedeOfrecerTasa">
        Todavía no hay tasa preferente autorizada: Dirección tiene que cargar el
        techo en la configuración. Sin ese número no se puede cerrar una
        recuperación.
      </p>

      <div class="gm-fila-botones">
        <button
          mat-flat-button
          color="primary"
          (click)="guardarFormulario()"
          [disabled]="guardando"
        >
          {{ guardando ? 'Guardando…' : 'Guardar' }}
        </button>
        <span class="gm-ayuda" *ngIf="!proximaAccion">
          Sin próxima acción, esta alerta no cuenta como gestionada.
        </span>
      </div>
    </div>

    <!-- --------------------------------------------------- historia semanal -->
    <div class="gm-bloque" *ngIf="semanas.length">
      <div class="gm-t">Qué le pasó, semana a semana</div>
      <div class="gm-tabla-wrap">
        <table class="gm-tabla">
          <thead>
            <tr>
              <th class="l">Semana</th>
              <th>USDT</th>
              <th>Ops</th>
              <th>Base</th>
              <th>%</th>
              <th class="l">Semáforo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of semanas">
              <td class="l" data-etq="Semana">
                {{ s.fechaInicio | date: 'dd/MM' }} – {{ s.fechaFin | date: 'dd/MM' }}
                <small *ngIf="s.dias !== 7">{{ s.dias }} días</small>
              </td>
              <td class="n" data-etq="USDT">{{ s.usdt | number: '1.0-0' }}</td>
              <td class="n" data-etq="Ops">{{ s.ops }}</td>
              <td class="n suave" data-etq="Base">{{ s.baseUsdt | number: '1.0-0' }}</td>
              <td class="n" data-etq="%">{{ porcentaje(s.ratioUsdt) }}</td>
              <td class="l" data-etq="Semáforo">
                <span class="sem" [class]="claseSemaforo(s.semaforo)"><i></i>{{ s.semaforo }}</span>
                <span class="gm-tag" *ngIf="s.semanasEnRojo >= 2">{{ s.semanasEnRojo }} sem</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ------------------------------------------------------------ bitácora -->
    <div class="gm-bloque">
      <div class="gm-t">Bitácora</div>
      <p class="gm-ayuda">
        No se edita ni se borra. Es lo que hace discutible el desempeño del equipo.
      </p>
      <div class="gm-bitacora">
        <div class="gm-evento" *ngFor="let e of eventos">
          <div class="gm-evento-cab">
            <span class="gm-evento-tipo">{{ etiquetaEvento(e) }}</span>
            <span class="gm-evento-fecha">{{ e.createdAt | date: 'dd/MM/yy HH:mm' }}</span>
          </div>
          <div class="gm-evento-detalle" *ngIf="e.detalle">{{ e.detalle }}</div>
          <div class="gm-evento-actor">
            {{ e.actorEmail || e.actorSub }}
            <span *ngIf="e.escenario">· {{ e.escenario.toLowerCase().replace('_', ' ') }}</span>
          </div>
        </div>
        <div class="gm-cargando" *ngIf="!eventos.length">Todavía no hay nada registrado.</div>
      </div>
    </div>
  </div>
</div>
